'use client'

import { getMiniPDPContext } from '@src/quince-site-pdp/src/domains/MiniPDPContext'
import { ProductPageBFFResponse } from '@src/quince-site-pdp/src/domains/ProductPageContext'
import MiniPDP from '@src/quince-site-pdp/src/templates/miniPDP/miniPDP'
import { FEATURE_FLAG_TYPE } from '@src/server-side/server-feature-flags/feature-flag.types'

import { ProductFeatureProvider } from '../components/product/productFeatureProvider'

import { PageTemplateProps } from './page-templates.types'

export default function MiniPDPPageTemplate({ pageData, serverSideFeatureFlags }: PageTemplateProps) {
  const pageDataJson = pageData.context.pageDataJson as ProductPageBFFResponse

  const productPrageProps = getMiniPDPContext(pageDataJson)

  const productFeatureFlags =
    serverSideFeatureFlags?.featureFlagType === FEATURE_FLAG_TYPE.PRODUCT ? serverSideFeatureFlags : null

  return (
    <ProductFeatureProvider serverSideFeatureFlags={productFeatureFlags}>
      <MiniPDP key={`${pageDataJson.product.id}-mini-pdp`} pageData={productPrageProps} />
    </ProductFeatureProvider>
  )
}
